const appInstance = process.env.NEXT_PUBLIC_APP_INSTANCE;

export const AppInstance = {
    isCzech: appInstance === "cz",
    isSlovak: appInstance === "sk",
} as const;
